"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.time = void 0;
const foundation_1 = require("../foundation");
exports.time = {
    productive: {
        fast: {
            ids_time_productive_fast: foundation_1.foundation_time.fast.time_fast_100ms,
            ids_time_productive_fast_input: foundation_1.foundation_time.moderate.time_moderate_175ms,
            ids_time_productive_fast_output: foundation_1.foundation_time.fast.time_fast_150ms,
        },
        moderate: {
            ids_time_productive_moderate: foundation_1.foundation_time.moderate.time_moderate_200ms,
            ids_time_productive_moderate_input: foundation_1.foundation_time.moderate.time_moderate_275ms,
            ids_time_productive_moderate_output: foundation_1.foundation_time.moderate.time_moderate_250ms,
        },
    },
    expressive: {
        moderate: {
            ids_time_expressive_moderate: foundation_1.foundation_time.moderate.time_moderate_400ms,
            ids_time_expressive_moderate_input: foundation_1.foundation_time.moderate.time_moderate_475ms,
            ids_time_expressive_moderate_output: foundation_1.foundation_time.moderate.time_moderate_450ms,
        },
        slow: {
            ids_time_expressive_slow: foundation_1.foundation_time.moderate.time_moderate_500ms,
            ids_time_expressive_slow_input: foundation_1.foundation_time.slow.time_slow_800ms,
            ids_time_expressive_slow_output: foundation_1.foundation_time.slow.time_slow_700ms,
        },
        looping: {
            ids_time_expressive_loop: foundation_1.foundation_time.slow.time_slow_none,
        },
    }
};
//# sourceMappingURL=time.js.map